// extracted by mini-css-extract-plugin
export default {"Body":"_Body--BZEv8","BodyContainer":"_BodyContainer--C090g","BodyText":"_BodyText--qTwtw","WarningIcon":"_WarningIcon--OC9wv","UpdateButton":"_UpdateButton--UCL3c"};